/*
  Ofertele ONE, pe tot site-ul. Configurarea vine din window.ONE_OFERTE,
  scrisa in layout/theme.liquid.

  1. Precizarile de transport si de volum, sub butonul de cumparare din fisa
     de produs, in sertarul cosului si pe pagina cosului. Calculul se face pe
     cosul real (/cart.js):
       - transport la usa gratuit de la pragul din Shopify, pe totalul cosului;
       - Easybox gratuit la orice comanda;
       - reducerea de volum la cafea, pe subtotalul cafelei din cos.
  2. Popupul de bun venit, ca la Constantin: in coltul din dreapta jos, dupa
     cateva secunde, cu abonare la newsletter. Dupa abonare, codul CAFEA5
     apare pe loc. Inchis, nu mai apare 7 zile; abonat, nu mai apare deloc.
*/
(function () {
  'use strict';
  var C = window.ONE_OFERTE;
  if (!C) return;

  function lei(bani) { return (Math.ceil(bani) / 100).toLocaleString('ro-RO', { maximumFractionDigits: 2 }) + ' lei'; }
  function citeste(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function scrie(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  /* ---------- 1. Transport si volum ---------- */

  var CAFEA = {};
  (C.cafea || []).forEach(function (id) { if (id) CAFEA[id] = true; });

  var cos = null, cerere = null;
  function iaCos(fortat) {
    if (cerere && !fortat) return cerere;
    cerere = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cos = c; return c; })
      .catch(function () { return cos; });
    return cerere;
  }

  function continut(c) {
    var total = c ? c.total_price : 0;
    var cafea = 0;
    if (c) c.items.forEach(function (i) { if (CAFEA[i.product_id]) cafea += i.original_line_price; });

    var pct = Math.min(100, Math.round(total / C.transportPrag * 100));
    var lipsa = C.transportPrag - total;
    var mesaj = !c || !c.item_count
      ? 'Transport gratuit la ușă pentru comenzi de minimum <b>' + lei(C.transportPrag) + '</b>.'
      : lipsa > 0
        ? 'Mai adaugi <b>' + lei(lipsa) + '</b> și ai transport gratuit la ușă.'
        : '<b>Ai transport gratuit la ușă.</b>';

    var volum = '';
    var urm = null, atins = null;
    (C.volum || []).forEach(function (t) { if (cafea >= t.prag) atins = t; else if (!urm) urm = t; });
    if (cafea > 0 && urm) volum = 'Mai pui cafea de <b>' + lei(urm.prag - cafea) + '</b> și primești <b>' + urm.pct + '% reducere</b> la cafea' + (atins ? ' (acum ai ' + atins.pct + '%)' : '') + '.';
    else if (atins) volum = '<b>Ai ' + atins.pct + '% reducere la cafea.</b> Se vede la finalizarea comenzii.';
    else volum = 'Cafea: <b>10%</b> reducere de la ' + lei(C.volum[0].prag) + ', <b>20%</b> de la ' + lei(C.volum[1].prag) + '.';

    var tarif = c && c.item_count && lipsa > 0 ? ' Până atunci, livrarea la ușă costă ' + lei(C.transportTarif) + '.' : '';

    return '<p class="one-liv__msg">' + mesaj + '</p>' +
      '<div class="one-liv__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Cât mai ai până la transport gratuit"><span style="width:' + pct + '%"></span></div>' +
      '<ul class="one-liv__info">' +
      '<li><b>Easybox:</b> gratuit la orice comandă.</li>' +
      '<li><b>La ușă:</b> gratuit de la ' + lei(C.transportPrag) + '.' + tarif + '</li>' +
      '<li>' + volum + '</li>' +
      '</ul>';
  }

  function widget() { var w = el('div', 'one-liv'); w.setAttribute('data-one-liv', ''); return w; }

  function locuri() {
    var l = [];
    /* fisa de produs: formularul principal, nu cardurile din pagina.
       Doar la cafea: transportul gratuit si reducerile de volum sunt
       pentru cafea, nu pentru echipamente sau alte produse. */
    if (/\/products\//.test(location.pathname) && C.produs && CAFEA[C.produs]) {
      var f = [].slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (x) {
        return !x.hasAttribute('data-one-gocart') && !x.closest('.one-card, [data-one-card], .cfg2, .quick-add-modal, theme-drawer, dialog');
      })[0];
      if (f) l.push({ dupa: f });
    }
    /* sertarul cosului */
    var d = document.querySelector('#cart-drawer .cart-drawer__content');
    if (d) l.push({ in: d, inainte: d.querySelector('.cart-drawer__items') });
    /* pagina cosului */
    if (/^\/cart\/?$/.test(location.pathname)) {
      var m = document.querySelector('main form[action*="/cart"]') || document.querySelector('main');
      if (m) l.push({ in: m.parentNode, inainte: m });
    }
    return l;
  }

  function aseaza() {
    locuri().forEach(function (loc) {
      var gazda = loc.dupa ? loc.dupa.parentNode : loc.in;
      if (!gazda || gazda.querySelector(':scope > [data-one-liv]')) return;
      var w = widget();
      if (loc.dupa) loc.dupa.insertAdjacentElement('afterend', w);
      else if (loc.inainte && loc.inainte.parentNode === gazda) gazda.insertBefore(w, loc.inainte);
      else gazda.insertBefore(w, gazda.firstChild);
    });
    var toate = document.querySelectorAll('[data-one-liv]');
    if (!toate.length) return;
    iaCos(true).then(function (c) {
      var h = continut(c);
      toate.forEach(function (w) { if (w.innerHTML !== h) w.innerHTML = h; });
    });
  }

  var t = null;
  function programeaza() { clearTimeout(t); t = setTimeout(aseaza, 350); }

  function pornesteLivrare() {
    aseaza();
    /* cosul se redeseneaza dupa fiecare adaugare; ne reasezam dupa el */
    var tinta = document.getElementById('cart-drawer');
    if (tinta) new MutationObserver(function (lista) {
      for (var i = 0; i < lista.length; i++) {
        var n = lista[i].target;
        if (n.closest && n.closest('[data-one-liv]')) continue;
        programeaza();
        return;
      }
    }).observe(tinta, { childList: true, subtree: true });
    document.addEventListener('cart:update', programeaza);
    document.addEventListener('cart:updated', programeaza);
  }

  /* ---------- 1b. Abonamentul, in fisa de produs ----------
     Planul vine din Appstle (Abonament cafea: lunar, 5% la fiecare comanda),
     citit din /products/<handle>.js. Widgetul Appstle nu se poate aseza pe
     formularul nostru, asa ca alegerea o facem aici: un camp ascuns
     selling_plan in #pdp-form, pe care one-cart.js il trimite cu FormData. */

  function abonament() {
    if (!/\/products\//.test(location.pathname)) return;
    var form = document.getElementById('pdp-form');
    if (!form || form.querySelector('[data-one-abo]')) return;
    var handle = location.pathname.split('/products/')[1].split(/[/?#]/)[0];
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p.selling_plan_groups || !p.selling_plan_groups.length) return;
        var plan = p.selling_plan_groups[0].selling_plans[0];
        if (!plan) return;
        var adj = (plan.price_adjustments || [])[0];
        var pct = adj && adj.value_type === 'percentage' ? adj.value : 0;

        var box = el('fieldset', 'one-abo');
        box.setAttribute('data-one-abo', '');
        box.innerHTML =
          '<legend>Opțiuni de plată</legend>' +
          '<label class="one-abo__opt"><input type="radio" name="one-abo" value="o-data" checked>' +
            '<span class="one-abo__t">Cumpărare o singură dată</span><span class="one-abo__p" data-p-o></span></label>' +
          '<label class="one-abo__opt"><input type="radio" name="one-abo" value="lunar">' +
            '<span class="one-abo__t">Abonament lunar' + (pct ? ' <em class="one-abo__badge">−' + pct + '%</em>' : '') +
            '<small>Livrare în fiecare lună, cu ' + pct + '% reducere la fiecare comandă. Se adaugă peste reducerea de volum. Poți renunța oricând.</small></span>' +
            '<span class="one-abo__p" data-p-a></span></label>' +
          '<input type="hidden" name="selling_plan" value="' + plan.id + '" disabled>';

        var btn = form.querySelector('button[type="submit"]');
        var gazda = btn ? btn.parentNode : form;
        if (btn && gazda === form) form.insertBefore(box, btn);
        else if (btn) gazda.parentNode.insertBefore(box, gazda);
        else form.appendChild(box);

        var ascuns = box.querySelector('[name="selling_plan"]');
        box.addEventListener('change', function (e) {
          if (e.target.name === 'one-abo') ascuns.disabled = e.target.value !== 'lunar';
        });

        function preturi() {
          var vid = parseInt((form.querySelector('[name="id"]') || {}).value, 10);
          var v = p.variants.filter(function (x) { return x.id === vid; })[0] || p.variants[0];
          var al = (v.selling_plan_allocations || []).filter(function (a) { return a.selling_plan_id === plan.id; })[0];
          box.querySelector('[data-p-o]').innerHTML = lei(v.price);
          box.querySelector('[data-p-a]').innerHTML = al
            ? lei(al.price) + ' <s>' + lei(v.price) + '</s>'
            : lei(v.price);
        }
        preturi();
        form.addEventListener('click', function () { setTimeout(preturi, 60); });
        form.addEventListener('change', function () { setTimeout(preturi, 60); });
      })
      .catch(function () {});
  }

  /* ---------- 2. Popupul de bun venit ---------- */

  var CHEIE_INCHIS = 'one_popup_inchis', CHEIE_TRIMIS = 'one_popup_trimis', CHEIE_ABONAT = 'one_popup_abonat';
  var ZILE = 7;

  function popupPermis() {
    if (C.client) return false;
    if (citeste(CHEIE_ABONAT)) return false;
    if (/^\/(cart|checkout|account|pages\/contact)/.test(location.pathname)) return false;
    var inchis = parseInt(citeste(CHEIE_INCHIS) || '0', 10);
    return !inchis || Date.now() - inchis > ZILE * 864e5;
  }

  function bannerConsimtamant() {
    var b = document.querySelector('#pandectes-banner, .pd-cookie-banner-window, [id^="pandectes"][role="dialog"]');
    if (!b) return false;
    var s = getComputedStyle(b);
    return s.display !== 'none' && s.visibility !== 'hidden' && b.offsetHeight > 0;
  }

  function popup(succes) {
    var p = el('div', 'one-pop');
    p.id = 'one-popup';
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-modal', 'false');
    p.setAttribute('aria-labelledby', 'one-pop-t');
    var corp = succes
      ? '<p class="one-pop__eyebrow">Bine ai venit</p>' +
        '<p class="one-pop__t" id="one-pop-t">Codul tău: <span class="one-pop__cod">' + C.cod + '</span></p>' +
        '<p class="one-pop__d">Îl scrii la finalizarea comenzii. Se aplică o singură dată, la cafea, și nu se adună cu reducerile de volum.</p>' +
        '<div class="one-pop__rand"><button type="button" class="one-pop__btn" data-copiaza>Copiază codul</button><a class="one-pop__link" href="/collections/cafea">Alege cafeaua</a></div>'
      : '<p class="one-pop__eyebrow">Newsletter ONE</p>' +
        '<p class="one-pop__t" id="one-pop-t">Obține 5% reducere la prima comandă</p>' +
        '<p class="one-pop__d">Abonează-te la newsletter și primești pe loc codul de 5% pentru cafea.</p>' +
        '<form method="post" action="/contact#one-popup" accept-charset="UTF-8" class="one-pop__f">' +
          '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="contact[tags]" value="newsletter, bun-venit-cafea5">' +
          '<label class="one-pop__vh" for="one-pop-email">E-mail</label>' +
          '<div class="one-pop__rand"><input type="email" id="one-pop-email" name="contact[email]" required autocomplete="email" placeholder="adresa ta de e-mail" spellcheck="false" autocapitalize="off">' +
          '<button type="submit" class="one-pop__btn">Vreau codul</button></div>' +
          '<label class="one-pop__acord"><input type="checkbox" required> <span>Sunt de acord să primesc e-mailuri de la ONE Coffee. Mă pot dezabona oricând. <a href="/policies/privacy-policy">Politica de confidențialitate</a>.</span></label>' +
        '</form>';
    p.innerHTML = '<button type="button" class="one-pop__x" aria-label="Închide">×</button>' + corp;

    p.querySelector('.one-pop__x').addEventListener('click', function () {
      scrie(CHEIE_INCHIS, String(Date.now()));
      p.remove();
    });
    var f = p.querySelector('form');
    if (f) f.addEventListener('submit', function () { scrie(CHEIE_TRIMIS, String(Date.now())); });
    var cp = p.querySelector('[data-copiaza]');
    if (cp) cp.addEventListener('click', function () {
      var gata = function () { cp.textContent = 'Copiat'; };
      if (navigator.clipboard) navigator.clipboard.writeText(C.cod).then(gata, gata); else gata();
    });
    document.body.appendChild(p);
    requestAnimationFrame(function () { p.classList.add('is-on'); });
  }

  function pornestePopup() {
    var q = location.search;
    var trimis = parseInt(citeste(CHEIE_TRIMIS) || '0', 10);
    if (/customer_posted=true/.test(q) && trimis && Date.now() - trimis < 30 * 60e3) {
      scrie(CHEIE_ABONAT, '1');
      try { localStorage.removeItem(CHEIE_TRIMIS); } catch (e) {}
      popup(true);
      return;
    }
    if (!popupPermis()) return;
    var incercari = 0;
    (function asteapta() {
      if (bannerConsimtamant() && incercari++ < 30) { setTimeout(asteapta, 2000); return; }
      popup(false);
    })();
  }

  function porneste() {
    try { pornesteLivrare(); } catch (e) { if (window.console) console.error('[one-oferte] livrare', e); }
    try { abonament(); } catch (e) { if (window.console) console.error('[one-oferte] abonament', e); }
    setTimeout(function () {
      try { pornestePopup(); } catch (e) { if (window.console) console.error('[one-oferte] popup', e); }
    }, /customer_posted=true/.test(location.search) ? 300 : 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste); else porneste();
})();
